import { RxAttachmentsAPI } from '@driftt/dapper'

import { generateBulkFetchURL } from 'utils/Helpers'
import { Attachment } from './models'

export const api = {
  fetch(ids) {
    return RxAttachmentsAPI
      .get(generateBulkFetchURL('/attachments', ids.toJS()))
      .checkStatus()
      .retryWithBackoff()
      .mapResponse(attachments => attachments.map(attachment => new Attachment({ ..._.omit(attachment, 'size'), size_: attachment.size })))
      // https://github.com/facebook/immutable-js/issues/1007
  },
  upload(conversationId, file) {
    const data = new FormData()
    data.append('file', file)
    data.append('conversationId', conversationId)
    return RxAttachmentsAPI
      .post('/attachments', data, { file: true })
      .checkStatus()
      .mapResponse(Attachment)
  },
}



// WEBPACK FOOTER //
// ./src/scripts/app/modules/message/attachment/api.js